import { render, staticRenderFns } from "./YSimpleMenu.vue?vue&type=template&id=597cc38a&scoped=true&"
import script from "./YSimpleMenu.vue?vue&type=script&lang=js&"
export * from "./YSimpleMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597cc38a",
  null
  
)

export default component.exports